export default {"src":"/_next/static/media/option-card-effect-purple.1dbb53f5.svg","height":220,"width":220,"blurWidth":0,"blurHeight":0};